export const SuccessPaymentIcon = ({
  strokeColor = "var(--color-icon-obscure)",
  ...props
}: any) => (
  <svg width="98" height="105" viewBox="0 0 98 105" fill="none">
    <rect
      x="1.25"
      y="0.75"
      width="77.5"
      height="103.5"
      rx="9.25"
      fill="var(--color-bg-third)"
      stroke="var(--color-stroke-active)"
      strokeWidth="1.5"
    />
    <path
      d="M19.692 18C19.5084 18.0005 19.3324 18.106 19.2026 18.2935C19.0729 18.481 19 18.7351 19 19C19 19.2649 19.0729 19.519 19.2026 19.7065C19.3324 19.894 19.5084 19.9995 19.692 20H70.308C70.4916 19.9995 70.6676 19.894 70.7974 19.7065C70.9271 19.519 71 19.2649 71 19C71 18.7351 70.9271 18.481 70.7974 18.2935C70.6676 18.106 70.4916 18.0005 70.308 18H19.692Z"
      fill="var(--color-stroke-active)"
    />
    <path
      d="M19.6858 22C19.5042 21.9998 19.33 22.1048 19.2014 22.2919C19.0728 22.479 19.0004 22.7329 19 22.9979C18.9996 23.2629 19.0713 23.5172 19.1994 23.7051C19.3274 23.893 19.5013 23.9991 19.6829 24H51.3147C51.4047 24 51.4938 23.9741 51.577 23.9239C51.6601 23.8736 51.7356 23.8 51.7993 23.7071C51.8629 23.6142 51.9134 23.504 51.9478 23.3827C51.9823 23.2614 52 23.1313 52 23C52 22.8687 51.9823 22.7386 51.9478 22.6173C51.9134 22.496 51.8629 22.3858 51.7993 22.2929C51.7356 22.2 51.6601 22.1264 51.577 22.0761C51.4938 22.0259 51.4047 22 51.3147 22H19.6858Z"
      fill="var(--color-stroke-active)"
    />
    <path
      d="M19.692 44C19.5084 44.0005 19.3324 44.106 19.2026 44.2935C19.0729 44.481 19 44.7351 19 45C19 45.2649 19.0729 45.519 19.2026 45.7065C19.3324 45.894 19.5084 45.9995 19.692 46H70.308C70.4916 45.9995 70.6676 45.894 70.7974 45.7065C70.9271 45.519 71 45.2649 71 45C71 44.7351 70.9271 44.481 70.7974 44.2935C70.6676 44.106 70.4916 44.0005 70.308 44H19.692Z"
      fill="var(--color-stroke-active)"
    />
    <path
      d="M19.6858 48C19.5042 47.9998 19.33 48.1048 19.2014 48.2919C19.0728 48.479 19.0004 48.7329 19 48.9979C18.9996 49.2629 19.0713 49.5172 19.1994 49.7051C19.3274 49.893 19.5013 49.9991 19.6829 50H51.3147C51.4965 50 51.6708 49.8946 51.7993 49.7071C51.9278 49.5196 52 49.2652 52 49C52 48.7348 51.9278 48.4804 51.7993 48.2929C51.6708 48.1054 51.4965 48 51.3147 48H19.6858Z"
      fill="var(--color-stroke-active)"
    />
    <path
      d="M19.692 69C19.5084 69.0005 19.3324 69.106 19.2026 69.2935C19.0729 69.481 19 69.7351 19 70C19 70.2649 19.0729 70.519 19.2026 70.7065C19.3324 70.894 19.5084 70.9995 19.692 71H70.308C70.4916 70.9995 70.6676 70.894 70.7974 70.7065C70.9271 70.519 71 70.2649 71 70C71 69.7351 70.9271 69.481 70.7974 69.2935C70.6676 69.106 70.4916 69.0005 70.308 69H19.692Z"
      fill="var(--color-stroke-active)"
    />
    <path
      d="M19.6858 73C19.5042 72.9998 19.33 73.1048 19.2014 73.2919C19.0728 73.479 19.0004 73.7329 19 73.9979C18.9996 74.2629 19.0713 74.5172 19.1994 74.7051C19.3274 74.893 19.5013 74.9991 19.6829 75H51.3147C51.4965 75 51.6708 74.8946 51.7993 74.7071C51.9278 74.5196 52 74.2652 52 74C52 73.7348 51.9278 73.4804 51.7993 73.2929C51.6708 73.1054 51.4965 73 51.3147 73H19.6858Z"
      fill="var(--color-stroke-active)"
    />
    <path
      d="M16 20C16 22.2091 14.2091 24 12 24C9.79086 24 8 22.2091 8 20C8 17.7909 9.79086 16 12 16C14.2091 16 16 17.7909 16 20Z"
      fill="#23B339"
    />
    <circle cx="12" cy="46" r="4" fill="#23B339" />
    <circle cx="12" cy="71" r="4" fill="#23B339" />
    <circle cx="78" cy="76" r="20" fill="#E9FAEC" />
    <circle
      cx="78"
      cy="76"
      r="10.6552"
      stroke="#23B339"
      strokeWidth="2.68966"
    />
    <path
      d="M73.5 74.6L77.5385 79L88.5 67"
      stroke="#23B339"
      strokeWidth="2.68966"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
